export default "__VITE_ASSET__Cn5HzBg6__"